import React, { useEffect, useRef, useState } from 'react';

interface ContadorAnimadoProps {
  final: number;
  duration?: number; // milissegundos
  prefix?: string;
  suffix?: string;
}

const ContadorAnimado: React.FC<ContadorAnimadoProps> = ({
  final,
  duration = 4000,
  prefix = '',
  suffix = '',
}) => {
  const [value, setValue] = useState(0);
  const raf = useRef<number | null>(null);

  useEffect(() => {
    let start: number | null = null;

    const animate = (timestamp: number) => {
      if (start === null) start = timestamp;
      const progress = Math.min((timestamp - start) / duration, 1);
      const currentValue = Math.floor(progress * (final));
      setValue(currentValue);
      if (progress < 1) {
        raf.current = requestAnimationFrame(animate);
      } else {
        setValue(final);
      }
    };

    setValue(0);
    raf.current = requestAnimationFrame(animate);

    return () => {
      if (raf.current !== null) cancelAnimationFrame(raf.current);
    };
  }, [final, duration]);

  const formatted = value.toLocaleString('en-US'); // ou 'en-US' para 2,184

  return (
    <span>
      {prefix}
      {formatted}
      {suffix}
    </span>
  );
};

export default ContadorAnimado;